import { render } from "./SignUp.vue?vue&type=template&id=4f30a66a&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=4f30a66a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alvar\\OneDrive\\Kaggle\\Vue\\pro_vouchers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f30a66a"]])

export default __exports__